import React from "react";

import MarkdownContainer from "../../MarkdownContainer";

import markdown from "../../../../markdown/universal/103_ip_marketing.md";

const IpMarketing = () => {
  return <MarkdownContainer markdown={markdown} />;
};

export default IpMarketing;
